import { useState } from "react";
import { BsDot } from "react-icons/bs";
import { FaAngleRight } from "react-icons/fa";

const SubCategoryList = ({ subCategory }) => {
  let itemWidth = "full";
  let maxHeight = "max-h-[1260px]";
  let colSpan = 1;
  if (subCategory?.children?.length > 36) {
    itemWidth = "1/2";
    colSpan = 2;
    if (subCategory?.children?.length) {
      maxHeight = "max-h-[1440px]";
    }
  }

  return (
    <div
      className={`flex ${maxHeight} flex-col flex-wrap bg-dropdownBg px-5 py-8 col-span-${colSpan}`}
    >
      {subCategory.name && (
        <p className="px-2 pb-2 font-pop text-sm font-bold text-darkGreen">
          {subCategory.name}
        </p>
      )}
      {subCategory.children?.map(({ name, quantity, id }) => (
        <p
          className={`w-${itemWidth} cursor-pointer py-2 px-2 font-pop text-xs font-normal text-darkGreen hover:bg-primary hover:text-white`}
        >
          {name} ({quantity || 0})
        </p>
      ))}
    </div>
  );
};

const NavCategoryItems = ({
  itemname,
  className,
  href,
  title,
  isArrow,
  time,
  dot,
  subCategories,
}) => {
  const [showSubCategory, setShowSubCategory] = useState(false);

  let colums = 0;
  let SubCategoryWidth = "w-[400px]";

  if (subCategories) {
    subCategories.forEach((subCategory) => {
      if (subCategory.children.length > 36) {
        colums++;
      }
      colums++;
    });

    if (subCategories[0].children?.length > 36) {
      SubCategoryWidth = "w-[550px]";
    }
  }
  switch (colums) {
    case 1:
      SubCategoryWidth = "w-[400px]";
      break;

    case 2:
      SubCategoryWidth = "w-[550px]";
      break;
    case 3:
      SubCategoryWidth = "w-[740px]";
      break;
    case 4:
      SubCategoryWidth = "w-[800px]";
      break;

    default:
  }

  const handleShowSubCategory = (e) => {
    setShowSubCategory((prevState) => !prevState);
  };

  return (
    <li className={`relative ${className}`} onClick={handleShowSubCategory}>
      <div className="flex items-center">{dot && <BsDot />}</div>
      <div className="flex items-center justify-between">
        <button to={href}>{itemname}</button>
        {isArrow && <FaAngleRight />}
        {time}
      </div>

      {subCategories && showSubCategory && (
        <div
          className={`absolute top-0 left-full max-h-96 ${SubCategoryWidth}`}
        >
          <h3 className="bg-primary py-3 text-center font-inter text-xl font-semibold text-white">
            {title}
          </h3>
          <div className={`grid grid-cols-${colums}`}>
            {subCategories.map((subCategory) => (
              <SubCategoryList subCategory={subCategory} />
            ))}
          </div>
          <div className=" h-4 bg-primary"></div>
        </div>
      )}
    </li>
  );
};

export default NavCategoryItems;
